import Layout from "../Layout";

export default [
  {
    path: "/",
    name: "frontpagelayout",
    component: Layout,
  }
];
